export default "__VITE_ASSET__uRZ9E_q6__"